import type { RouteObject } from "react-router-dom";

import NotFound from "../pages/NotFound";

import Home from "../pages/home/page";

import ServiciosPage from "../pages/servicios/page";

import HSEConInteligenciaPage from "../pages/hse-con-inteligencia/page";

import GestionDocumentalPage from "../pages/gestion-documental/page";

import AuditoriasPage from "../pages/auditorias/page";

import AsesoriaPage from "../pages/asesoria-terreno/page";

import SistemasGestionPage from "../pages/sistemas-gestion/page";

import CapacitacionPage from "../pages/capacitacion/page";

import ContactoPage from "../pages/contacto/page";

import SafelineAiHubPage from "../pages/safeline-ai-hub/page";

const routes: RouteObject[] = [

  {
    path: "/",
    element: <Home />,
  },

  {
    path: "/servicios",
    element: <ServiciosPage />,
  },

  {
    path: "/hse-con-inteligencia",
    element: <HSEConInteligenciaPage />,
  },

  {
    path: "/gestion-documental",
    element: <GestionDocumentalPage />,
  },

  {
    path: "/auditorias",
    element: <AuditoriasPage />,
  },

  {
    path: "/asesoria-terreno",
    element: <AsesoriaPage />,
  },

  {
    path: "/sistemas-gestion",
    element: <SistemasGestionPage />,
  },

  {
    path: "/capacitacion",
    element: <CapacitacionPage />,
  },

  {
    path: "/contacto",
    element: <ContactoPage />,
  },

  {
    path: "/safeline-ai-hub",
    element: <SafelineAiHubPage />,
  },

  {
    path: "*",
    element: <NotFound />,
  },

];

export default routes;